module.exports = __webpack_public_path__ + "img/banner2EN.43b3bfe6.png";